module.exports = __webpack_public_path__ + "img/asset_RAY-soETH.f2b26c92.png";